// extracted by css-extract-rspack-plugin
export default {"forgotPWLink":"_82830d55","forgotPwLink":"_82830d55"};